import { FirearmStorageLocationServiceBase } from './firearm-storage-location.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { addPageSpecificationParameters, appendSerialisedHttpParams, ENVIRONMENT, HateoasMultipleResponseObject, markAsBackgroundServiceCall, PageSpecification } from '@scisys-uim/uim-common';
import { FirearmStorageLocation } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FirearmStorageLocationService extends FirearmStorageLocationServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }


  public findByFullFiltersExtended(filters: any, pageSpec?: PageSpecification, reduced: boolean = true, backgroundServiceCall: boolean = false): Observable<HateoasMultipleResponseObject<FirearmStorageLocation>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<FirearmStorageLocation>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params,
      headers: backgroundServiceCall ? markAsBackgroundServiceCall() : null
    }));
  }
}



